import { useEffect } from "react";

export default function useOverflowYHidden(overflowYHidden) {
  useEffect(() => {
    if (overflowYHidden) {
      document.body.style.overflowY = "hidden";
    } else {
      document.body.style.overflowY = "";
    }
    return () => {
      document.body.style.overflowY = "";
    };
  }, [overflowYHidden]);
}
